import Request from './request';

export default class ProductDeliveryDateHttpService {
    private static uri = 'product-delivery-dates';

    public static async index(params: {}) {
        return Request.get(this.uri, params);
    }

    public static async show(id: string) {
        return Request.get(`${this.uri}/${id}`);
    }

    public static async store(data: {}) {
        return Request.post(this.uri, data);
    }

    public static async update(data: {}) {
        return Request.patch(this.uri, data);
    }

    public static async destroy(id: number) {
        return Request.del(`${this.uri}/${id}`);
    }

    public static async import(csv: FormData) {
        return Request.post(`${this.uri}/import`, csv, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

    public static async removeByRecordOrigin(recordOrigin: string) {
        return Request.del(`${this.uri}?recordOrigin=${recordOrigin}`);
    }
}
